import { createSlice } from "@reduxjs/toolkit";

    const createDeviceSlice = createSlice({
    name: "deviceCreate",
    initialState: {
        currentDevice: null,
        isFetching: false,
        error: false
    },
    reducers: {
        createDeviceStart: (state) => {
        state.isFetching = true;
        },
        createDeviceSuccess: (state, action) => {
            state.isFetching = false;
            state.currentDevice = action.payload
            state.error = false;
        },
        createDeviceFailure: (state) => {
            state.currentDevice = null;
            state.isFetching = false;
            state.error = true;
        }
    },
    });


export const { createDeviceStart, createDeviceSuccess, createDeviceFailure } = createDeviceSlice.actions;
export default createDeviceSlice.reducer;